import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';

export const City = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<TextField
			label={t('parking_details_form_city_label')}
			placeholder={t('parking_details_form_city_placeholder')}
			invalid={!!errors.city}
			error={errors.city?.message}
			autoComplete="address-level2"
			{...props}
			{...register('city')}
		/>
	);
};
